import React, { useState } from "react";
import { Button } from "react-bootstrap";

const AuthService = () => {
  const [ value, setValue ] = useState("");
  const tokenHandler = e => {
    setValue(e.target.value);
  };

  const sumbitToken = (e) => {
    e.preventDefault()
    const regexp = value.match(/#access_token=(.*?)&/)
    if (regexp === null) {
      alert('wrong token')
      setValue('')
    } else if(regexp[1].length === 85) {
      localStorage.setItem("token", regexp[1])
      window.location.reload()
    } else {
      setValue('')
      alert('Неправильный формат токена')
    }
  }
  return (
    <div className='auth'>
      <a
        href="https://oauth.vk.com/authorize?client_id=7317464&display=page&redirect_uri=&scope=friends,photos&response_type=token&v=5.52"
        rel="noopener noreferrer"
        target="_blank"
      >
        Получить токен (скопируйте адресную строку целиком в поле ниже)
      </a>
      <form onSubmit={(e)=>sumbitToken(e)}>
      <input
        placeholder="введите ваш токен..."
        className="token"
        onChange={e => tokenHandler(e)}
      />
      <Button type='submit'>Потвердить</Button>
      </form>
      
    </div>
  );
};

export default AuthService;
